import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AccountInfo } from '@azure/msal-browser';
import { AppService } from '../../../service/app.service';
import { Utente } from '../../../interfaces/user';
import { ItDropdownComponent, ItDropdownItemComponent, ItHeaderComponent, ItIconComponent } from 'design-angular-kit';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule, ItDropdownComponent, ItDropdownItemComponent, ItIconComponent, ItHeaderComponent],
  templateUrl: './header.component.html',

})
export class HeaderComponent {
  @Input('user') user: Utente | null = null;
  isAdmin: boolean = this.appService.user.isUtenteAdmin ?? false;
  constructor(
    private router: Router,
    private appService: AppService,
    private authService: MsalService,
  ) { }

  redirect(url:string) {
    this.router.navigate([url]);
  }

  logout() {
    this.authService.logoutRedirect();
  }
}
